import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "../../styles.css"

const TableRow = ({ children, className, ...props }) => {
  const tableRowClass = classnames(styles.tableRowClass, className)
  return (
    <tr {...props} className={tableRowClass}>
      {children}
    </tr>
  )
}

TableRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}
export default TableRow



// WEBPACK FOOTER //
// ./src/components/Table/components/TableRow/index.js